import { useAuthenticatedFetch } from '@launchnotes/common-hooks/useAuthenticatedFetch';
import API_URL from '../../API_URL';
import { message } from 'antd';
import useProjectId from '@launchnotes/common-hooks/useProjectId';

export const getFlatfileKey = async () => {
  const { authenticatedFetch } = useAuthenticatedFetch();
  const projectId = useProjectId();
  const url = `${API_URL}/projects/${projectId}/flatfile/authenticate`;
  return await authenticatedFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(async (result) => {
    if (result.ok) {
      const { token } = await result.json()
      return token
    } else {
      message.error('We could not authenticate this request.');
    }
  })
}
